<template>
    <div class="divider"></div>
</template>

<style lang="scss" scoped>
@use '../styles/global.scss';

.divider {
    width: 100%;
    height: 1em;
    background-color: #e5e5f7;
    opacity: 0.8;
    background: repeating-linear-gradient(-45deg, global.$spice, global.$spice 5px, transparent 5px, transparent 25px);
    background-size: 30px 30px;
    animation: divider-scroll 2s linear infinite;

    &:nth-of-type(even) {
        animation-direction: reverse;
    }
}

@media (prefers-reduced-motion: reduce) {
    .divider {
        animation: none;
    }
}

@keyframes divider-scroll {
    from {
        background-position: 0 0;
    }

    to {
        background-position: 30px 0;
    }
}
</style>